import Head from "next/head";

const Meta = (
    {title, canonical, description, keywords} : 
    {title: string, canonical: string, description: string, keywords: string}) => {
        
    return ( 
        <Head>
            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
    
            <title>{title}</title>
            <link rel="canonical" href={canonical}/>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            <meta property="og:url" content={canonical}/>
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={description} />
            <meta property="og:image" content="https://static.tildacdn.com/tild3136-3961-4530-a530-353033633939/_.png"/>
            <meta property="og:type" content="website" />

            <meta name="yandex-verification" content="2e1b8cdc128b3660"/>
            
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,700;1,700&display=swap" 
                rel="stylesheet"></link>
            <script src="/__ENV.js" />
            <script src="/service/__ENV.js" />
        </Head>
    );
}

export default Meta;